// Shared badge colour maps + ordering for the compliance-report UI.
// Extracted from ComplianceReportViewer.svelte so the viewer, the findings
// table, the metrics grid and the reports route all render the SAME palette
// (the route previously re-declared overallColors/fallbackBadge by hand).

// Report-level overall status → badge classes.
export const overallColors = {
  compliant: 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-300 dark:border-emerald-700',
  partial: 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border-amber-300 dark:border-amber-700',
  'action-required': 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 border-red-300 dark:border-red-700',
  unknown: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-600',
};

// Section status → badge classes.
export const sectionColors = {
  pass: 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-300 dark:border-emerald-700',
  warn: 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border-amber-300 dark:border-amber-700',
  fail: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 border-red-300 dark:border-red-700',
  informational: 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 border-blue-300 dark:border-blue-700',
  'not-applicable': 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 border-gray-300 dark:border-gray-600',
};

// Finding severity → badge classes.
export const severityColors = {
  critical: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 border-red-300',
  high: 'bg-orange-100 dark:bg-orange-900/40 text-orange-700 dark:text-orange-300 border-orange-300',
  medium: 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border-amber-300',
  low: 'bg-yellow-100 dark:bg-yellow-900/40 text-yellow-700 dark:text-yellow-300 border-yellow-300',
  info: 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 border-blue-300',
};

// Portfolio checklist status → badge classes.
export const checklistColors = {
  provided: 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-300',
  missing: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 border-red-300',
  'needs-review': 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border-amber-300',
};

// Finding lifecycle status → badge classes (stamped at ingest by the
// finding-lifecycle service; resolved findings reach the UI via summary.delta).
export const findingStatusColors = {
  open: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 border-red-300',
  'in-progress': 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 border-blue-300',
  resolved: 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-300',
  accepted: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-300',
};

// Solid severity tints for the findings-table left colour rail.
export const severityRail = {
  critical: 'bg-red-500',
  high: 'bg-orange-500',
  medium: 'bg-amber-500',
  low: 'bg-yellow-400',
  info: 'bg-blue-500',
};

// Severity display + sort order (worst → least).
export const severityOrder = ['critical', 'high', 'medium', 'low', 'info'];

// Sort weight: lower sorts first when severity-descending.
export const severityWeight = { critical: 0, high: 1, medium: 2, low: 3, info: 4 };

export const fallbackBadge = 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-600';
